import Vue from 'vue'
import { isNil } from 'lodash'

Vue.filter('pmlStripTag', function (value) {
    return !isNil(value) ? value.replace(/<(?:.|\n)*?>/gm, '') : ''
})



// WEBPACK FOOTER //
// ./src/utils/filters/strip-tag.js